import React from 'react';
import { NavLink as ReactNavLink } from 'react-router-dom';

const Link = ({
  children,
  ...rest
}) => {
  return (
    <ReactNavLink
      activeClassName="active-nav-link"
      {...rest}
    >
      {children}
    </ReactNavLink>
  );
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/landing/components/navigation/Link.js